(() => {
    window.Vendallion = window.Vendallion || {};

    Vendallion.PopupModal = function (options) {
        const popupModalHTML = createElement(`
            <div class="popup-modal-backdrop ${options.modalClass || ""}">
                <div class="overflow">
                    <div class="center-vertical">
                        <div class="modal ${options.modalClass || ""}">
                            <button class="close" aria-label="Close"> 
                                <span class="close-icon">
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.814365 9.53559C0.358754 9.9912 0.358753 10.7299 0.814365 11.1855C1.26998 11.6411 2.00867 11.6411 2.46428 11.1855L5.99981 7.64997L9.53535 11.1855C9.99096 11.6411 10.7297 11.6411 11.1853 11.1855C11.6409 10.7299 11.6409 9.99121 11.1853 9.53559L7.64973 6.00006L11.1853 2.46452C11.6409 2.00891 11.6409 1.27022 11.1853 0.814609C10.7297 0.358998 9.99096 0.358997 9.53535 0.81461L5.99981 4.35014L2.46428 0.81461C2.00867 0.358998 1.26998 0.358998 0.814365 0.81461C0.358753 1.27022 0.358753 2.00891 0.814365 2.46453L4.3499 6.00006L0.814365 9.53559Z" fill="#17224B"></path></svg>
                                </span>
                            </button>
                            <div class="modal-content">                          
                                ${options.content ? options.content : ""}
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        `);

        if (options.moveContent) {
            let contentElement = document.querySelector(options.moveContent);
            if (contentElement) {
                //check if the element is template
                if (contentElement.tagName.toLowerCase() === "template") {
                    contentElement = contentElement.content.cloneNode(true).firstElementChild;
                }
                contentElement.classList.remove("hidden");
                popupModalHTML.querySelector(".modal-content").appendChild(contentElement);
            } else {
                console.warn(`Element with selector "${options.moveContent}" not found.`);
            }
        }

        Vendallion.PopupModal.Close = function () {
            document.body.style.overflow = "auto";
            if (options.moveContent) {
                const contentElement = document.querySelector(options.moveContent);
                if (contentElement) {
                    contentElement.classList.add("hidden");
                    document.body.appendChild(contentElement); // Move it back to the body
                }
            }
            popupModalHTML.remove();
            options.onClose && options.onClose();
        };

        document.body.style.overflow = "hidden";
        document.body.appendChild(popupModalHTML);
        options.onOpen && options.onOpen(popupModalHTML);

        // Add click event to backdrop to close the modal except for cookies popup
        const backdropContainer = popupModalHTML.querySelector(".popup-modal-backdrop:not(.cookies-popup) .center-vertical");
        if (backdropContainer) {
            backdropContainer.addEventListener("click", (e) => {
                if (e.target === popupModalHTML.querySelector(".center-vertical") || e.target.classList.contains("close")) {
                    Vendallion.PopupModal.Close();
                }
            });
        }

        function createElement(html) {
            const template = document.createElement("template");
            template.innerHTML = html.trim();
            return template.content.firstChild;
        }
    };

    const popUpBtns = document.querySelectorAll('[data-action="popup"]');
    if (popUpBtns.length === 0) return;

    popUpBtns.forEach((btn) => {
        const popupId = btn.getAttribute("data-popup-id");
        const popupClass = btn.getAttribute("data-popup-class");
        const popupElement = document.getElementById(popupId);
        if (!popupElement) return;

        btn.addEventListener("click", () => {
            Vendallion.PopupModal({
                moveContent: `#${popupId}`,
                modalClass: popupClass,
                onOpen: function (popupModal) {},
                onClose: function () {},
            });
        });
    });
})();
